import { j as m } from "../../_virtual/jsx-runtime.js";
import { c } from "../../_virtual/compiler-runtime.js";
import { cn as n } from "../../utils/cn.js";
const a = (i) => {
  const e = c.c(9);
  let l, o;
  e[0] !== i ? ({
    className: l,
    ...o
  } = i, e[0] = i, e[1] = l, e[2] = o) : (l = e[1], o = e[2]);
  let t;
  e[3] !== l ? (t = n("inline-block", l), e[3] = l, e[4] = t) : t = e[4];
  let s;
  e[5] === Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m.jsx("path", { d: "M5 6H2V12H5V6ZM9.5 1H6.5V12H9.5V1ZM14 4H11V12H14V4ZM2 13.5V15H14V13.5H2Z" }), e[5] = s) : s = e[5];
  let r;
  return e[6] !== o || e[7] !== t ? (r = /* @__PURE__ */ m.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "16", height: "16", fill: "currentColor", role: "img", focusable: "false", className: t, ...o, children: s }), e[6] = o, e[7] = t, e[8] = r) : r = e[8], r;
};
a.displayName = "ColumnChartIcon";
export {
  a as ColumnChartIcon
};
